import {toast as reactToast} from 'react-semantic-toasts';
import HTMLReactParser from 'html-react-parser';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import './react.Toasts.scss';
import {isOnline} from '../../lib/hooks/useOnlineStatus.js';
import {isArray} from "../../lib/helpers/isArray";

const defaults = {
    animation: 'drop',
    time: 5000

};

export const warningToast = (msg) => reactToast({
    type: 'warning',
    icon: 'exclamation',
    description: HTMLReactParser(msg),
    ...defaults

});

export const successToast = (msg) => reactToast({
    type: 'success',
    icon: 'check',
    description: HTMLReactParser(msg),
    ...defaults

});

export const errorToast = (msg) => {

    if (isArray(msg)) {
        msg = msg.join('<br/>');
    }


    reactToast({
        type: 'warning',
        description: HTMLReactParser(msg),
        icon: 'cancel',
        ...defaults

    });
};

export const infoToast = (msg) => reactToast({
    type: 'info',
    description: HTMLReactParser(msg),
    ...defaults

});

export const toast = (options) => reactToast(options);

export const requestErrorToast = (msg) => isOnline() && reactToast({
    type: 'warning',
    description: HTMLReactParser(msg),
    icon: 'warning sign',
    ...defaults
});